import { plainMarkdownTableCellText } from '../components/MarkdownTableCell';

/** Start of a SERFF-style inline citation (matches Answers MarkdownLite). */
const CITATION_START_REGEX = /(?:\[\s*)?(?:SERFF[-\u2010-\u2015])?[A-Z]+[-\u2010-\u2015]\d+(?:,\s*[^\],;]+)?,\s*(?:Pages?|pages?|pp?\.)\s*\d+/i;

export const getFirstCitationIndex = (text) => {
  const match = CITATION_START_REGEX.exec(String(text || ''));
  return match ? match.index : -1;
};

/** Remove semicolons only in the prefix before the first citation. */
export const stripSemicolonsBeforeFirstCitation = (text) => {
  const raw = String(text || '');
  const firstCitation = getFirstCitationIndex(raw);
  if (firstCitation < 0) return raw.replace(/^[\s;]+/, '');
  return raw.slice(0, firstCitation).replace(/;/g, '') + raw.slice(firstCitation);
};

export const findSourceColumnIndex = (headerRow = []) => {
  if (!headerRow?.length) return -1;
  return headerRow.findIndex((cell) => {
    const label = plainMarkdownTableCellText(cell).toLowerCase();
    return label === 'source' || label.startsWith('source ');
  });
};
